import React from 'react';
import { Image } from 'react-bootstrap';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { backgroundThemeState, contactButtonHoverState } from '../../../atoms';
import * as Icon from '../../../data/photoUrls';
import { useContactButtonHover } from '../../../util/hooks';

export default function Resume() {
  const downloadRef = React.useRef(null);
  const background = useRecoilValue(backgroundThemeState);
  const setContactButtonHoverState = useSetRecoilState(contactButtonHoverState);
  useContactButtonHover(background, '.download');

  React.useEffect(() => {
    setContactButtonHoverState(background);
  }, []);

  const download = (e: any): void => {
    fetch(e.target.href, {
      method: 'GET',
      headers: {},
    })
      .then((response) => {
        response.arrayBuffer().then((buffer) => {
          const url = window.URL.createObjectURL(new Blob([buffer]));
          const link = document.createElement('a');

          link.href = url;
          link.setAttribute('download', 'cv.pdf');

          document.body.appendChild(link);
          link.click();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="resume">
      <a href={require('./cv.pdf')} className="customLink" onClick={download}>
        <span
          ref={downloadRef}
          className="text-light download"
          style={{ marginLeft: '10px' }}
        >
          resume
        </span>
        <Image
          src={Icon.download}
          style={{ marginLeft: '10px', marginBottom: '0.3rem' }}
          alt=""
          width="18px"
        />
      </a>
    </div>
  );
}
